var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainn"},[_c('ReturnProcess',{on:{"selectSalesPerson":_vm.setSalesPerson}}),_c('ReturnProcessToStock',{attrs:{"sales-person-full-name":_vm.salesPersonFullName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }